import { render, staticRenderFns } from "./GroupMoneyLists.vue?vue&type=template&id=2503e03c"
import script from "./GroupMoneyLists.vue?vue&type=script&lang=js"
export * from "./GroupMoneyLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports